import { SectionHeading } from '@/features/approving_invoice_reports/components/PaymentDetailDrawer/components/SectionHeading';
import { useTranslation } from '@/i18n';
import { FC, memo } from 'react';
import { TransactionsDetail } from './Table';

type TransactionsDetailSectionProps = {
  reportId: string;
};

export const TransactionsDetailSection: FC<TransactionsDetailSectionProps> =
  memo(({ reportId }) => {
    const { t } = useTranslation();
    return (
      <SectionHeading title={t('approving_invoice_reports.transactions.title')}>
        <TransactionsDetail reportId={reportId} />
      </SectionHeading>
    );
  });
TransactionsDetailSection.displayName = 'TransactionsDetailSection';
